/* BalmCare routine quiz. No network calls, cookies, trackers or saved answers.
 * All product links are centralized here for a later Shopify integration.
 * Keep this a classic script so the exported pages also work from file://.
 */
(function (scope) {
  'use strict';
  const cfg = (scope && scope.BCL_QUIZ) || {};
  const base = (cfg.root || '/').replace(/\/?$/, '/') + 'products/';
  const asset = file => (cfg.assetBase || 'assets/') + 'bcl-' + file;
  const products = {
    beard: {name: 'Baardverzorgingspakket', detail: 'Serum, balsem, roller, sanitizer en kam.', url: base + 'baardverzorging-pakket', image: asset('beard-kit-original.webp')},
    skin: {name: 'Huidverzorgingspakket', detail: 'Charcoal Cleanser, gezichtscrème en Depilation Rub.', url: base + 'huidverzorging-pakket', image: asset('skin-kit-closed-original.webp')},
    combined: {name: 'Baard- & huidverzorgingspakket', detail: 'Het baardpakket en het huidpakket samen.', url: base + 'combo-deal', image: asset('combined-original.webp')},
    moisturizer: {name: 'Gezichtscrème voor huid & baard', detail: 'Hydratatie voor je gezicht, ook onder je baard.', url: base + 'moisturizer', image: asset('moisturizer-original.webp')},
    cleanser: {name: 'Charcoal Cleanser', detail: 'De reinigingsstap voor je gezicht.', url: base + 'charcoal-cleanser', image: asset('cleanser-original.webp')},
    serum: {name: 'Baardserum', detail: 'Verzorging voor je baard. Inhoud: 30 ml.', url: base + 'beard-serum', image: asset('serum-original.webp')}
  };
  const option = (value, label, description, mark) => ({value, label, description, mark});
  function getQuestion(step, answers) {
    if (step === 0) return {topic: 'Jouw focus', title: 'Waar wil jij aandacht aan geven?', intro: 'Kies je focus. We houden het overzichtelijk.', options: [
      option('beard', 'Mijn baard', 'Verzorging voor mijn baard en de huid eronder.', '01'),
      option('skin', 'Mijn huid', 'Een goede basis voor mijn gezicht.', '02'),
      option('both', 'Baard én huid', 'Ik wil mijn verzorging samen aanpakken.', '03')
    ]};
    if (step === 1) {
      if (answers[0] === 'beard') return {topic: 'Wat jij zoekt', title: 'Wat wil je je baard geven?', intro: 'Kies wat nu voor jou het belangrijkste is.', options: [
        option('care', 'Meer verzorging', 'Een vast verzorgingsmoment voor mijn baard.', '01'),
        option('hydrate', 'Aandacht voor de huid eronder', 'Hydratatie voor mijn gezicht onder mijn baard.', '02'),
        option('routine', 'Een vaste routine', 'Verzorging en styling bij elkaar.', '03')
      ]};
      if (answers[0] === 'skin') return {topic: 'Wat jij zoekt', title: 'Waar begint jouw huidverzorging?', intro: 'Waar wil je als eerste aandacht aan besteden?', options: [
        option('cleanse', 'Goed reinigen', 'Een reinigingsstap voor mijn gezicht.', '01'),
        option('hydrate', 'Mijn huid hydrateren', 'Een verzorgingsstap na het wassen.', '02'),
        option('routine', 'De basis op orde', 'Ik zoek een logische combinatie.', '03')
      ]};
      if (answers[0] === 'both') return {topic: 'Wat jij zoekt', title: 'Wat krijgt als eerste aandacht?', intro: 'Zo maken we je startpunt concreet.', options: [
        option('beard-first', 'Eerst mijn baard', 'Daar wil ik mijn routine op richten.', '01'),
        option('skin-first', 'Eerst mijn huid', 'Ik begin bij reinigen en hydrateren.', '02'),
        option('equal', 'Allebei evenveel', 'Ik wil een basis voor mijn hele gezicht.', '03')
      ]};
      throw new Error('Kies eerst een geldige focus.');
    }
    if (step === 2) return {topic: 'Jouw aanpak', title: 'Hoe wil je beginnen?', intro: 'Een kleine eerste stap of de producten samen in één pakket.', options: [
      option('compact', 'Houd het compact', 'Begin met één of twee passende producten.', '01'),
      option('complete', 'Geef me een compleet pakket', 'Ik wil de verzorging en extra’s samen bekijken.', '02')
    ]};
    if (step === 3) return {topic: 'Jouw startpunt', title: 'Heb je al een verzorgingsroutine?', intro: 'Dit bepaalt hoe we je adviseren te beginnen.', options: [
      option('new', 'Ik begin net', 'Leg mijn eerste stap kort en duidelijk uit.', '01'),
      option('existing', 'Ik heb al een routine', 'Ik wil gericht aanvullen wat ik gebruik.', '02')
    ]};
    throw new Error('Onbekende vraag.');
  }
  function validateAnswers(answers) {
    if (!Array.isArray(answers) || answers.length !== 4) return false;
    try { return answers.every((value, step) => getQuestion(step, answers).options.some(o => o.value === value)); }
    catch (_) { return false; }
  }
  function recommend(answers) {
    if (!validateAnswers(answers)) throw new Error('Beantwoord eerst alle vier de vragen.');
    const [focus, goal, approach, experience] = answers;
    let ids, title, reason;
    if (approach === 'complete') {
      if (focus === 'beard') {
        ids = ['beard']; title = 'Jouw baard. Een vaste routine.';
        reason = goal === 'hydrate' ? 'Je kiest voor het complete baardverzorgingspakket, met aandacht voor de huid eronder. Bekijk bij elk onderdeel de toepassing; zoek je specifiek een gezichtscrème, dan kun je die ook los bekijken.' : 'Je wilt je baard aandacht geven en kiest graag één compleet pakket. Met serum, balm en tools heb je verzorging en styling bij elkaar.';
      } else if (focus === 'skin') {
        ids = ['skin']; title = 'Een vaste basis voor je huid.';
        reason = 'Je kiest voor je gezichtshuid en wilt de producten samen. Het huidverzorgingspakket combineert reinigen en hydrateren, met de Rub als aanvullende stap.';
      } else {
        ids = ['combined']; title = 'Baard én huid. Samen verzorgd.';
        reason = 'Je wilt beide verzorgen en kiest voor een compleet pakket. Daarom past de combinatie van baard- en huidproducten bij jouw voorkeur.';
      }
    } else if (focus === 'beard') {
      if (goal === 'hydrate') {
        ids = ['moisturizer']; title = 'Begin bij de huid onder je baard.';
        reason = 'Je wilt compact beginnen en geeft de huid onder je baard aandacht. De gezichtscrème is een gerichte eerste stap voor hydratatie van je gezicht.';
      } else {
        ids = ['serum']; title = 'Eén verzorgingsstap voor je baard.';
        reason = 'Je wilt je baard verzorgen en klein beginnen. Bekijk daarom eerst het baardserum; een compleet pakket kun je later altijd nog overwegen.';
      }
    } else if (focus === 'skin') {
      if (goal === 'cleanse') {
        ids = ['cleanser']; title = 'Jouw begin: een reinigingsstap.';
        reason = 'Je wilt goed reinigen en zoekt één eerste product. De Charcoal Cleanser sluit aan op die keuze.';
      } else if (goal === 'hydrate') {
        ids = ['moisturizer']; title = 'Geef je huid hydratatie.';
        reason = 'Je wilt hydrateren en compact beginnen. De gezichtscrème is de verzorgingsstap die daarbij past.';
      } else {
        ids = ['cleanser', 'moisturizer']; title = 'Reinigen. Hydrateren. Klaar.';
        reason = 'Je wilt de basis op orde met weinig producten. Begin met een reiniger en een moisturizer, zonder meteen alle extra’s toe te voegen.';
      }
    } else if (goal === 'beard-first') {
      ids = ['serum', 'moisturizer']; title = 'Je baard eerst. Je huid doet mee.';
      reason = 'Je wilt beide verzorgen, begint bij je baard en houdt het compact. Bekijk serum voor je baard en moisturizer voor je gezicht.';
    } else {
      ids = ['cleanser', 'moisturizer']; title = 'Begin met de basis van je gezicht.';
      reason = 'Je wilt baard en huid aandacht geven met weinig producten. Reinigen en hydrateren is jouw gekozen startpunt; baardstyling kun je later toevoegen.';
    }
    let firstStep;
    if (ids.includes('combined')) firstStep = goal === 'beard-first' ? 'Begin met de baardverzorging en voeg de gezichtsverzorging stap voor stap toe.' : 'Begin met de reiniging en hydratatie van je gezicht. Geef daarna de baardverzorging een plek.';
    else if (ids.includes('skin') || ids.includes('cleanser')) firstStep = 'Reinigen komt vóór hydrateren. De Rub is een aanvullende stap met een eigen gebruiksaanwijzing.';
    else if (ids.includes('beard')) firstStep = 'Maak verzorging en styling herkenbare momenten. De roller en sanitizer hebben elk hun eigen gebruiksinstructies.';
    else if (ids.length === 2) firstStep = 'Geef serum en moisturizer elk een eigen plek in je routine. Bekijk voor beide de juiste toepassing op het etiket.';
    else if (ids[0] === 'moisturizer') firstStep = 'Geef de gezichtscrème een plek na het reinigen van je gezicht. Volg de hoeveelheid en toepassing op het etiket.';
    else firstStep = 'Lees de gebruiksaanwijzing van het serum en geef het een vast moment in je verzorging.';
    const start = experience === 'new' ? 'Begin met één nieuwe stap tegelijk. ' + firstStep : 'Vergelijk deze keuze met wat je al gebruikt en vul gericht aan. ' + firstStep;
    return {title, reason, ids, products: ids.map(id => products[id]), start, startHeading: experience === 'new' ? 'Zo begin je eenvoudig' : 'Zo vul je jouw routine aan', summary: answers.slice(0,3).map((value,i) => getQuestion(i,answers).options.find(o=>o.value===value).label), detailLink: focus === 'beard' ? ((cfg.pages || {}).beard || '/') : ((cfg.pages || {}).skin || '/')};
  }
  function init(root) {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const ui = root.querySelector('[data-quiz-ui]');
    const form = root.querySelector('[data-quiz-form]');
    const title = root.querySelector('[data-question-title]');
    const intro = root.querySelector('[data-question-intro]');
    const options = root.querySelector('[data-options]');
    const next = root.querySelector('[data-next]');
    const back = root.querySelector('[data-back]');
    const resultElement = root.querySelector('[data-result]');
    const announcer = root.querySelector('[data-announcer]');
    const progress = root.querySelector('[role="progressbar"]');
    let answers = [], step = 0;
    ui.hidden = false;
    function make(tag, className, text) { const node = document.createElement(tag); if (className) node.className = className.split(' ').map(c => 'bcl-' + c.replace(/^bc-/, '')).join(' '); if (text) node.textContent = text; return node; }
    function renderQuestion(moveFocus) {
      const question = getQuestion(step, answers);
      form.hidden = false; resultElement.hidden = true;
      title.textContent = question.title; intro.textContent = question.intro;
      root.querySelector('[data-step-label]').textContent = 'Vraag ' + (step + 1) + ' van 4';
      root.querySelector('[data-step-topic]').textContent = question.topic;
      progress.setAttribute('aria-valuenow', String(step + 1));
      progress.setAttribute('aria-valuetext', 'Vraag ' + (step + 1) + ' van 4');
      root.querySelector('.bcl-quiz-progress-fill').style.width = ((step + 1) * 25) + '%';
      options.replaceChildren(make('legend', 'bc-sr-only', question.title + ' Kies één antwoord.'));
      question.options.forEach(o => {
        const label = make('label', 'quiz-option');
        const mark = make('span', 'quiz-option-mark', o.mark); mark.setAttribute('aria-hidden','true');
        const copy = make('span'); copy.append(make('strong','',o.label), make('small','',o.description));
        const input = make('input'); input.type = 'radio'; input.name = 'answer'; input.value = o.value; input.required = true; input.checked = answers[step] === o.value;
        label.append(mark, copy, input); options.append(label);
      });
      back.disabled = step === 0;
      next.disabled = !question.options.some(o => o.value === answers[step]);
      next.replaceChildren(document.createTextNode(step === 3 ? 'Bekijk mijn routine ' : 'Volgende '));
      const arrow = make('span','','→'); arrow.setAttribute('aria-hidden','true'); next.append(arrow);
      if (moveFocus) { announcer.textContent = 'Vraag ' + (step+1) + ' van 4. ' + question.title; const focusTarget = options.querySelector('input:checked') || options.querySelector('input'); focusTarget.focus({preventScroll:true}); }
    }
    function renderResult() {
      const result = recommend(answers);
      form.hidden = true; resultElement.hidden = false; resultElement.replaceChildren();
      root.querySelector('[data-step-label]').textContent = 'Jouw resultaat';
      root.querySelector('[data-step-topic]').textContent = 'Gebaseerd op jouw keuzes';
      progress.setAttribute('aria-valuenow','4'); progress.setAttribute('aria-valuetext','Quiz afgerond');
      root.querySelector('.bcl-quiz-progress-fill').style.width = '100%';
      resultElement.append(make('p','quiz-result-eyebrow','Jouw routineadvies'),make('h2','',result.title),make('p','quiz-result-reason',result.reason));
      const summary = make('ul','quiz-result-summary'); summary.setAttribute('aria-label','Jouw keuzes'); result.summary.forEach(s=>summary.append(make('li','',s))); resultElement.append(summary);
      const winkel = (window.BCL_QUIZ && window.BCL_QUIZ.winkel) || {};
      let eersteKnop = null;
      result.ids.forEach((id,i)=>{
        const p = result.products[i];
        const live = winkel[id] || {};
        const card = make('div','quiz-result-product');
        const photo = make('img'); photo.src=live.foto||p.image; photo.alt=p.name; photo.width=100; photo.height=100; photo.loading='lazy';
        const detail=make('div','quiz-result-detail');
        detail.append(make('strong','',p.name),make('p','',p.detail));
        if(live.prijs){
          const prijs=make('p','quiz-result-price');
          if(live.vanaf){const s=make('s','',live.vanaf);prijs.append(s);}
          prijs.append(make('b','',live.prijs));
          detail.append(prijs);
        }
        const acties=make('div','quiz-result-acties');
        if(live.variant && live.voorraad){
          const form=document.createElement('form'); form.method='post'; form.action=(window.BCL_QUIZ&&window.BCL_QUIZ.root||'/').replace(/\/$/,'')+'/cart/add';
          const vid=document.createElement('input'); vid.type='hidden'; vid.name='id'; vid.value=live.variant;
          const aantal=document.createElement('input'); aantal.type='hidden'; aantal.name='quantity'; aantal.value='1';
          const knop=make('button','button quiz-result-knop','In winkelwagen'); knop.type='submit';
          const pijl=make('span','','\u2197'); pijl.setAttribute('aria-hidden','true'); knop.append(pijl);
          form.append(vid,aantal,knop); acties.append(form);
          if(!eersteKnop) eersteKnop=knop;
        }
        if(live.url||p.url){const link=make('a','quiz-result-link','Bekijk het product \u2197');link.href=live.url||p.url;acties.append(link);}
        detail.append(acties);
        card.append(photo,detail);resultElement.append(card);
      });
      const belofte = (window.BCL_QUIZ && window.BCL_QUIZ.belofte) || '';
      if(belofte) resultElement.append(make('p','quiz-result-belofte',belofte));
      const losse = ['serum','cleanser','moisturizer'];
      if(result.ids.length && result.ids.every(id=>losse.includes(id))){
        const naarPakket = result.ids.includes('serum') ? 'beard' : 'skin';
        const pak = winkel[naarPakket];
        if(pak && pak.url){
          const extra=make('p','quiz-result-upsell');
          extra.append(document.createTextNode('Wil je in \u00e9\u00e9n keer alles? '));
          const l=make('a','','Bekijk het '+(naarPakket==='beard'?'baardverzorgingspakket':'huidverzorgingspakket')+(pak.prijs?' \u00b7 '+pak.prijs:'')+' \u2197');
          l.href=pak.url; extra.append(l); resultElement.append(extra);
        }
      }
      const start=make('div','quiz-result-start');start.append(make('h3','',result.startHeading),make('p','',result.start));resultElement.append(start);
      const restart=make('button','quiz-back quiz-restart','\u2190 Opnieuw kiezen');restart.type='button';restart.addEventListener('click',()=>{answers=[];step=0;renderQuestion(true);});resultElement.append(restart);
      announcer.textContent='Jouw advies: '+result.title+' '+result.reason;
      if(eersteKnop) eersteKnop.focus({preventScroll:true});
    }
    form.addEventListener('change',event=>{
      if(event.target.name!=='answer')return;
      const value=event.target.value;
      if(!getQuestion(step,answers).options.some(o=>o.value===value))return;
      if(answers[step]!==value){answers=answers.slice(0,step);answers[step]=value;}
      next.disabled=false;
    });
    form.addEventListener('submit',event=>{event.preventDefault();if(!getQuestion(step,answers).options.some(o=>o.value===answers[step]))return;if(step<3){step++;renderQuestion(true);}else renderResult();});
    back.addEventListener('click',()=>{if(step>0){step--;renderQuestion(true);}});
    renderQuestion(false);
  }
  const api={getQuestion,recommend,validateAnswers,products,init};
  if(typeof module!=='undefined'&&module.exports) module.exports=api;
  if(scope){scope.BalmQuiz=api;if(typeof document!=='undefined'){const boot=()=>document.querySelectorAll('[data-quiz-root]').forEach(init);document.addEventListener('shopify:section:load',boot);if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();}}
})(typeof window!=='undefined'?window:null);
